import { StyleSheet } from 'react-native';
import { borderRadius, darkGrey, fontFamily } from '../../../constants/palette';

export default StyleSheet.create({
  container: {
    marginBottom: 10,
  },
  sessionStateContainer: {
    backgroundColor: darkGrey,
    width: 88,
    height: 80,
    borderRadius,
    flexDirection: 'column',
    justifyContent: 'center',
    textAlign: 'center',
    textAlignVertical: 'center',
  },
  switchContainer: {
    marginTop: 10,
    alignItems: 'center',
    justifyContent: 'center',
  },
});
